export default __webpack_public_path__ + "static/media/04_malina.ab435046.jpg";